module.exports = __webpack_public_path__ + "img/BMW.606af30.jpg";